import { ISubMenuItem } from '@models/IHeader';
import SubNavTab from '@organisms/Header/subNav/SubNavTab';
import updateDataLayer from '@utils/helpers/gtm';
import useIsInIFrame from '@utils/hooks/useIsInIFrame';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

interface Props {
  readonly activeTab: ISubMenuItem[];
  readonly mainCategory: string;
}

const MobileSecondLevelContent = ({ activeTab, mainCategory }: Props) => {
  const [activeSubNavContent, setActiveSubNavContent] =
    useState<ISubMenuItem>();
  const [activeNavItemIndex, setActiveNavItemIndex] = useState(0);
  const [subCategory, setSubCategory] = useState('');
  const isInIFrame = useIsInIFrame();

  const handleLevelTwoClick = (item: string) => {
    setSubCategory(item);
    updateDataLayer({
      event: 'menuUsed',
      content_type: 'header_menu_level_2',
      main_category: mainCategory,
      sub_category: item,
      tertiary_category: undefined,
    });
  };

  const classes = classNames({
    'w-full': true,
  });

  useEffect(() => {
    const { navigationCards, links } = activeTab[0]!;
    setActiveSubNavContent({ navigationCards, links });
  }, [activeTab]);

  return (
    <motion.div className={classes}>
      <motion.ul className="flex flex-row flex-nowrap overflow-x-auto bg-white pt-7 pr-5 pb-7 pl-5 md:pr-8 md:pl-8 lgm:pr-32 lgm:pl-32">
        {activeTab?.map(
          ({ link, navigationCards, links, title = '' }, index) => {
            const linkTitle = link?.name;
            const linkUrl = link?.url;
            const linkTarget = link?.target;

            return linkUrl && !navigationCards?.length ? (
              <motion.li
                key={`level-2-${linkTitle}`}
                className={classNames(
                  'cursor-pointer pr-5',
                  activeNavItemIndex === index
                    ? 'text-black-100'
                    : 'text-grey-500'
                )}
                data-testid="CT-01-Header-Mobile-Second-Level-Sub-Nav-Item"
              >
                <span className="flex flex-col items-center gap-2.5">
                  <a
                    href={linkUrl}
                    target={isInIFrame ? '_parent' : linkTarget}
                  >
                    <div
                      className="second-level-nav-title body-two whitespace-nowrap"
                      data-testid="CT-01-Header-Mobile-Second-Level-Sub-Nav-Item-Title"
                    >
                      {title}
                    </div>
                  </a>
                  {activeNavItemIndex === index ? (
                    <div className="h-2 w-2 rounded-full bg-yellow" />
                  ) : null}
                </span>
              </motion.li>
            ) : (
              <motion.li
                key={`level-2-${linkTitle}`}
                className={classNames(
                  'pr-5',
                  activeNavItemIndex === index
                    ? 'text-black-100'
                    : 'text-grey-500',
                  navigationCards?.length ? 'cursor-default' : 'cursor-pointer'
                )}
              >
                <button
                  onClick={() => {
                    setActiveNavItemIndex(index);
                    handleLevelTwoClick(title);
                    setActiveSubNavContent({
                      navigationCards,
                      links,
                    });
                  }}
                >
                  <span className="flex flex-col items-center gap-2.5">
                    <div
                      className="second-level-nav-title body-two whitespace-nowrap"
                      data-testid="CT-01-Header-Mobile-Second-Level-Sub-Nav-Item-Title"
                    >
                      {title}
                    </div>
                    {activeNavItemIndex === index ? (
                      <div className="h-2 w-2 rounded-full bg-yellow" />
                    ) : null}
                  </span>
                </button>
              </motion.li>
            );
          }
        )}
      </motion.ul>

      <SubNavTab
        activeTab={activeSubNavContent || {}}
        mainCategory={mainCategory}
        subCategory={subCategory}
        dataTestId="CT-01-Header-Sub-Nav-Tab"
      />
    </motion.div>
  );
};

export default MobileSecondLevelContent;
